"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var R = __importStar(require("../../utils/ramda"));
require("react-date-range/dist/styles.css"); // main style file
require("react-date-range/dist/theme/default.css"); // theme css file
require("./DatePicker.css");
var react_date_range_1 = require("react-date-range");
var Row_1 = require("../../components/Row");
var classnames_1 = __importDefault(require("classnames"));
var TimePicker_1 = require("./TimePicker");
var locale_1 = require("../../utils/locale");
var DatePicker = function (_a) {
  var _b, _c, _d, _e, _f;
  var date = _a.date,
    _g = _a.onChange,
    onChange = _g === void 0 ? R.N : _g,
    _h = _a.showTimePicker,
    showTimePicker = _h === void 0 ? false : _h,
    _j = _a.locale,
    locale = _j === void 0 ? "en" : _j,
    className = _a.className,
    _k = _a.disabled,
    disabled = _k === void 0 ? false : _k,
    disabledDates = _a.disabledDates,
    disabledDay = _a.disabledDay,
    disabledTime = _a.disabledTime,
    timeInterval = _a.timeInterval,
    restProps = __rest(_a, ["date", "onChange", "showTimePicker", "locale", "className", "disabled", "disabledDates", "disabledDay", "disabledTime", "timeInterval"]);
  var ref = (0, react_1.useRef)(null);
  var _l = __read((0, react_1.useState)(new Date()), 2),
    shownDate = _l[0],
    setShownDate = _l[1];
  var _m = __read((0, react_1.useState)(0), 2),
    timePickerHeight = _m[0],
    setTimePickerHeight = _m[1];
  var time = date ? {
    hours: (_b = date.getHours()) !== null && _b !== void 0 ? _b : 0,
    minutes: (_c = date.getMinutes()) !== null && _c !== void 0 ? _c : 0
  } : undefined;
  var onDateChange = function (d) {
    var _a, _b;
    var dt = new Date(d);
    dt.setHours((_a = date === null || date === void 0 ? void 0 : date.getHours()) !== null && _a !== void 0 ? _a : 0, (_b = date === null || date === void 0 ? void 0 : date.getMinutes()) !== null && _b !== void 0 ? _b : 0, 0, 0);
    onChange(dt);
  };
  var onTimeChange = function (t) {
    var _a;
    var d = (_a = R.clone(date)) !== null && _a !== void 0 ? _a : new Date();
    d.setHours(t.hours, t.minutes, 0, 0);
    onChange(d);
  };
  (0, react_1.useLayoutEffect)(function () {
    var _a, _b;
    var child = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.firstElementChild;
    var h = ((_b = child === null || child === void 0 ? void 0 : child.clientHeight) !== null && _b !== void 0 ? _b : 300) - 45;
    setTimePickerHeight(h);
  }, [date, locale, shownDate, ref, ref.current, (_d = ref.current) === null || _d === void 0 ? void 0 : _d.firstElementChild, (_f = (_e = ref.current) === null || _e === void 0 ? void 0 : _e.firstElementChild) === null || _f === void 0 ? void 0 : _f.clientHeight]);
  return (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    className: (0, classnames_1.default)(className, "vsx-datetime-picker"),
    inline: true
  }, restProps, {}, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      ref: ref
    }, {
      children: (0, jsx_runtime_1.jsx)(react_date_range_1.Calendar, {
        fixedHeight: true,
        locale: (0, locale_1.getLocale)(locale),
        onShownDateChange: setShownDate,
        date: date,
        onChange: onDateChange,
        disabledDay: disabled ? R.T : disabledDay,
        disabledDates: disabledDates
      })
    })), showTimePicker && (0, jsx_runtime_1.jsx)(TimePicker_1.TimePicker, {
      interval: timeInterval,
      disabled: disabled,
      disabledTime: disabled ? R.T : disabledTime,
      height: timePickerHeight,
      selected: time,
      onChange: onTimeChange
    })]
  }));
};
exports.DatePicker = DatePicker;